import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import replaceText from 'components/ttb-home/util'

const PartialListBlock = ({
  listData: { answerDetail, answerTitle, onSiteAnswerOption },
  t,
}) => (
  <span className={clsx('ttb-faq__content-body', Typo.price2)}>
    {answerTitle && replaceText(t, answerTitle)}
    {answerDetail?.nonTTBHAllow && <br />}
    {onSiteAnswerOption?.nonTTBHAllow && replaceText(t, onSiteAnswerOption)}
    {answerDetail?.nonTTBHAllow && replaceText(t, answerDetail)}
  </span>
)

PartialListBlock.propTypes = {
  listData: PropTypes.shape({
    answerDetail: PropTypes.shape({
      nonTTBHAllow: PropTypes.bool,
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    answerTitle: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    onSiteAnswerOption: PropTypes.shape({
      nonTTBHAllow: PropTypes.bool,
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(PartialListBlock)
